import { API_BASE_URL } from "@lib/config"
import type { PersonalizationUploadResponse } from "@lib/util/personalization"
import { readJsonResponse } from "@lib/http/read-json-response"

export type UploadPersonalizationFileParams = {
  file: File
  optionId: string
  productId?: string
  productSlug?: string
  previousUploadId?: string
  cartId?: string
  cartItemId?: string
  signal?: AbortSignal
}

export async function uploadPersonalizationFile(
  params: UploadPersonalizationFileParams
): Promise<PersonalizationUploadResponse> {
  const formData = new FormData()
  formData.append("file", params.file)
  formData.append("optionId", params.optionId)

  if (params.productId) {
    formData.append("productId", params.productId)
  }
  if (params.productSlug) {
    formData.append("productSlug", params.productSlug)
  }
  if (params.previousUploadId) {
    formData.append("previousUploadId", params.previousUploadId)
  }
  if (params.cartId) {
    formData.append("cartId", params.cartId)
  }
  if (params.cartItemId) {
    formData.append("cartItemId", params.cartItemId)
  }

  const response = await fetch(`${API_BASE_URL}/public/personalization/uploads`, {
    method: "POST",
    body: formData,
    cache: "no-store",
    signal: params.signal,
  })

  const payload: any = await readJsonResponse(response, {
    context: "personalization upload",
    optional: true,
  })

  if (!response.ok) {
    const message =
      payload && typeof payload === "object" && typeof payload.error === "string"
        ? payload.error
        : "No se pudo subir el archivo de personalización."
    throw new Error(message)
  }

  if (!payload || typeof payload !== "object" || typeof payload.uploadId !== "string") {
    throw new Error("Respuesta inválida del servidor al subir el archivo.")
  }

  return payload as PersonalizationUploadResponse
}
